import React, { useEffect, useState } from "react";
import { OmnijusSelectField } from "../fields/omnijus-select-field";
import { Loading } from "@omnijus/common";
import { AgendamentoProcessoService } from "../../../services/agendamento/agendamento-processo-service";

interface OmnijusFiltroStatusAgendamentoProps {
    hideLabel?: boolean;
    name?: string;
    label?: string;
    isDisabled?: boolean;
    isMulti?: boolean;
}

export const OmnijusFiltroStatusAgendamento = (props: OmnijusFiltroStatusAgendamentoProps) => {
    const [promiseOpcoes, setPromiseOpcoes] = useState<Promise<{ id: number; value: string }[] | undefined>>();

    useEffect(() => {
        setPromiseOpcoes(AgendamentoProcessoService.listarStatusAgendamento());
    }, []);

    return (
        <Loading promise={promiseOpcoes}>
            {(opcoes) => (
                <OmnijusSelectField
                    isMulti={props.isMulti}
                    name={props.name || "idStatusAgendamento"}
                    label={props.label}
                    options={opcoes
                        ?.map((o) => ({
                            value: o.id.toString(),
                            label: o.value.toString(),
                        }))
                        .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0))}
                />
            )}
        </Loading>
    );
};
